import React from "react";
import { Link } from "react-router-dom";
import {
  Paper,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  CardActions,
} from "@material-ui/core";

import style from "./devices.module.scss";
import { Button } from "../button";
import { translate } from "../../translations/translate";

export const DeviceLine = (props) => {

  const {
    data: {
      statisticsActive = 0,
    },
  } = props;

  const statsActive = statisticsActive > 0;
  return (<Card>
    <CardHeader title={props.data.name} subheader={props.data.address} />
    <Divider />
    <CardActions>
      <div className={style["buttons"]}>
        <Link to={`/controller/${props.data.uuid}`} >
          <Button label={translate("admin.controller")} />
        </Link>
        <Link to={`/device/${props.data.uuid}`}>
          <Button label={translate("admin.start-gate")} />
        </Link>
        <Link to={`/device2/${props.data.uuid}`}>
          <Button label={translate("admin.start-gate2")} />
        </Link>
        <Link to={`/device3/${props.data.uuid}`}>
          <Button label={translate("admin.start-gate-queue")} />
        </Link>
        <Link to={`/settings/${props.data.uuid}`}>
          <Button label={translate("settings")} />
        </Link>
        {/* <Link to={`/greenpass`}>
          <Button label="Verifica GreenPass" />
        </Link> */}
        {statsActive && (
          <Link to={`/statistics/${props.data.uuid}`}>
            <Button label={translate("statistics")} />
          </Link>
        )}
      </div>
    </CardActions>
  </Card>);
};

export const DevicesTable = (props: any) => {
  const { devices } = props;
  return (<Grid alignItems="center" justifyContent="center" direction="column" container>
    {devices.map((e, i) =>
    (<Grid item xs={12} sm={8} key={i}>
      <DeviceLine data={e} />
    </Grid>))}
  </Grid>);
};
